import { render, staticRenderFns } from "./jianDuTouSu.vue?vue&type=template&id=58732f09&scoped=true&"
import script from "./jianDuTouSu.vue?vue&type=script&lang=js&"
export * from "./jianDuTouSu.vue?vue&type=script&lang=js&"
import style0 from "./jianDuTouSu.vue?vue&type=style&index=0&id=58732f09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58732f09",
  null
  
)

export default component.exports